const pt = {
  numberOfChargers: `Número de Carregadores`,
  numberOfChargingSessions: `Número de Sessões de Carregamento`,
  numberOfUsers: `Número de Utilizadores`,
  numberOfVehicles: `Número de Veículos`,
  numberOfKWH: `Número de KW's`,
  chargingAmount: `Número de Sessões de Carregamento`,
  chargeAmount: `Quantidade de carregamentos`,
  chargerStatus: `Estado do Carregador`,
  usersLogged: `Utilizadores Logados`,
  username: `Nome de Utilizador`,
  password: `Palavra-passe`,
  passwordConfirm: `Confirmar Palavra-passe`,
  userGroupRequired: 'Se requere um grupo de utilizadores',
  newPassword: `Nova Palavra-passe`,
  confirmNewPassword: `Confirmar Nova Palavra-passe`,
  currentPassword: `Palavra-passe Atual`,
  validEmail: `Insira um email válido`,
  addCreditToUser: `Adicionar créditos ao utilizador`,
  addCredit: `Adicionar Crédito`,
  group: `Grupo`,
  addCreditToGroup: `Adicionar Crédito ao Grupo:`,
  address1: `Endereço 1`,
  address2: `Endereço 2`,
  deleteAgent: `Eliminar Agente`,
  billingFrequencyRequired: `Se requere a frequência de facturação`,
  billingFrequency: `Frequência de Facturação`,

  chargingProfiles: 'Perfis de Caregamento',
  addChargingProfile: 'Adicionar Perfil de Caregamento',
  editChargingProfile: 'Editar Perfil de Caregamento',

  balance: 'Carteira',
  commission: 'Comissão',
  resultsNotFound: `Nenhum resultado encontrado`,
  chargerPictures: `Fotos do Carregador`,

  priceMinValue: `O valor mínimo é 0`,

  rejectSelectedConfirm: 'Tem a certeza de que deseja rejeitar item selecionado?',
  reject: 'Rejeitar',
  rejectSelected: 'Rejeitar foto selecionado',
  deleteSelectedItems: 'Tem a certeza de que deseja eliminar itens selecionados?',
  providerAccount: 'Origem da conta',

  updatePasword: `Actualizar Palavra-passe?`,
  login: `Entrar`,
  logout: `Sair`,
  welcome: 'Seja bem vindo ao',
  seeliggExplain: 'Plataforma para gestão de carregamento de carros eléctricos',
  signin: `Faça login no Seeligg Backoffice`,
  forgotPassword: `Esqueces-te da Palavra-passe?`,
  rememberMe: `Relembrar-me`,
  insertDetails: `Insira os detalhes abaixos`,
  email: `Email`,
  website: `Página Web`,

  useLoadBalance: 'Usar LoadBalance',

  priceRequired: `O preço é obrigatório`,

  changeTariffPrice: `Alterar Preço da tarifa`,
  tariffList: `Lista de tarifas`,
  tariffsManagement: `Gestão de Tarifas`,
  walletstransactions: `Transações de carteira `,
  newTransaction: `Nova Transação`,
  print: `Imprimir`,
  transactionsManagemant: `Gestão de Transações`,
  credits: `Créditos`,
  firmwareVersion: `Versão do Firmware`,
  chargerProvider: `Fornecedor do Carregador`,
  maxCharger: `Capacidade da Bateria`,
  maxCharge: `Máx. de carregamento`,
  typeRequired: `Tipo é obrigatório`,
  countryRequired: `Pais é obrigatório`,
  maxVoltage: `Potência Máxima`,
  loadebalanceLimit: `Limite de dinheiro de carregamento`,
  observation: `Observação`,
  ocppChargers: 'Carregadores OCPP',
  deleteAllSelected: `Tem a certeza de que deseja excluir todos os itens selecionados?`,
  deleteVehicleMessage: `Tem a certeza de que deseja eliminar todos os veículos selecionados?`,
  ocppChargersList: 'Lista de Carregadores OCPP',
  sorryPageNotFound: `Desculpe, página não encontrada`,
  pageNotFoundTitle:
    'Desculpe, não foi possível encontrar a página que você está procurando. Talvez você tenha digitado incorretamente o URL? Certifique-se de verificar a sua ortografia.',
  goHome: 'Ir para a página inicial',
  addProviderMessage: `Este carregador não tem provedor atribuído, é necessário atribuir um provedor primeiro para poder editar a localização`,
  title404: '404 Página não encontrada',
  title500: '500 Erro interno do servidor',
  tryLatter: 'Ocorreu um erro, tente novamente mais tarde.',
  operation: `Operação`,
  transactions: `Transações`,
  tariff: `Tarifa`,
  name: `Nome`,
  send: `Enviar`,
  surname: `Apelido`,
  chargeState: 'Estado de Carregamento',
  firstname: `Primeiro Nome`,
  lastname: `Último Nome`,
  phoneNumber: `Telefone`,
  address: `Endereço`,
  image: `Imagem`,
  year: `Ano`,
  of: `do`,
  privateIP: `IP privado`,
  publicIP: `IP publico`,
  postalCode: `Código Postal`,
  city: `Cidade`,
  country: `País`,
  language: `Idioma`,
  description: `Descrição`,
  role: `Função`,
  roles: `Funções`,
  user: `Utilizador`,
  users: `Utilizadores`,
  userProfile: `Perfil do Utilizador`,
  vehicle: `Veículo`,
  vehicles: `Veículos`,
  charger: `Carregador`,
  ocppChargers: 'Carregadores OCPP',
  creditsManagement: 'Gestão de Créditos',
  chargers: `Carregadores`,
  maxAmps: `Máx. de Amperes`,
  maxVoltage: `Tensão Máxima de Carregamento`,
  sucess: `Sucesso`,
  sucessful: `com sucesso.`,
  addedSucessful: `adicionado com sucesso.`,
  updatedSucessful: `atualizado com sucesso.`,
  updatePassword: `Atualizar Palavra-passe`,
  deletedSucessful: `eliminado com sucesso.`,
  error: `Erro`,
  errorOccured: `Ocorreu um erro.`,
  errorOccuredTryAgain: `Ocorreu um erro. Por favor tente novamente.`,
  errorOccuredTryAgainLater: `Ocorreu um erro. Por favor tente novamente mais tarde.`,
  vehiclesManagement: `Gestão de Veículos`,
  usersManagement: `Gestão de Utilizadores`,
  chargersManagement: `Gestão de Carregadores`,
  providers: `Provedores`,
  provider: `Provedor`,
  addUser: `Adicionar Utilizador`,
  addProvider: `Adicionar Provedor`,
  addVehicle: `Adicionar Veículo`,
  addCharger: `Adicionar Carregador`,
  addBrand: `Adicionar Marca`,
  addModel: `Adicionar Modelo`,
  addOutletType: `Adicionar Tomada`,
  providersList: `Lista de Provedores`,
  chargerList: `Lista de Carregadores`,
  chargersWithoutLocation: `Carregadores sem Localização`,
  chargersWithoutProvisioning: `Carregadores não registados`,
  chargersInformation: `Informação dos Carregadores`,
  amperes: 'Amps',
  chargersAdminMode: `Colocar carregadores em Modo Administrador`,
  chargerLogs: `Registo dos Carregadores`,
  vehicleList: `Lista de Veículos`,
  usersList: `Lista de Utilizadores`,
  brandsList: `Lista de Marcas`,
  modelsList: `Lista de Modelos`,
  firmwareList: `Lista de Firmwares`,
  outletTypesList: `Lista de Tomadas`,
  userInfo: `Informações do usuário`,
  settings: `Definições`,
  hardwareRequired: `O id do hardware é necessária`,
  approveSelected: 'Aprovar fotos selecionadas',
  picturesSelected: ' imagem(ns) selecionada(s)',
  noPicturesSelected: 'Nenhuma imagem selecionada',
  approveSelectedConfirm: 'Tem certeza de que deseja aprovar as imagens selecionadas?',
  approve: 'Aprovar',
  pictures: 'Imagens',
  next: `Seguinte`,
  back: `Voltar`,
  new: `Novo`,
  add: `Adicionar`,
  edit: `Editar`,
  delete: `Eliminar`,
  generateQRCodes: `Gerar Códigos QR`,
  search: `Pesquisar`,
  searchHere: `Pesquise aqui ...`,
  save: `Guardar`,
  cancel: `Cancelar`,
  brand: `Marca`,
  brands: `Marcas`,
  model: `Modelo`,
  roads: 'Estradas',
  satellite: 'Satélite',
  editTariff: `Editar Tarifa`,
  createTariff: `Criar Tarifa`,
  models: `Modelos`,
  outletType: `Tomada`,
  id: `ID`,
  evConnected: `Veículo connectado`,
  evNotCharging: `Carregador offline`,
  evNotConnected: `Veículo não connectado`,
  connector: `Conector`,
  addConnector: `Adicionar Conector`,
  outletTypes: `Tomadas`,
  outletTypesAssociated: `Tomadas associadas a este modelo`,
  editUser: `Editar Utilizador`,
  editUserProfile: `Editar Perfil do Utilizador`,
  editUserProfilePassword: `Editar Palavra-passe do Utilizador`,
  editProvider: `Edit Provider`,
  editVehicle: `Editar Veículo`,
  editCharger: `Editar Carregador`,
  editChargerInformation: `Editar Informação do Carregador`,
  creditsManagement: `Gestão de Créditos`,
  editBrand: `Editar Marca`,
  editModel: `Editar Modelo`,
  editOutletType: `Editar Tomada`,
  updateChargerLocation: 'Atualizar Localização do Carregador?',
  editChargerLocation: `Editar Localização do Carregador`,
  deleteConfirmationA: `Tem a certeza que deseja apagar este`,
  deleteConfirmationB: `Tem a certeza que deseja apagar esta`,
  createUser: `Criar novo utilizador`,
  createVehicle: `Criar novo veículo`,
  createCharger: `Criar novo carregador`,
  createBrand: `Criar nova marca`,
  createModel: `Criar novo modelo`,
  createOutletType: `Criar nova tomada`,
  amount: `Valor`,
  map: `Mapa`,

  update: `Atualizar `,
  upload: `Carregar `,

  currentPerPhaseRequired: `A corrente por fase é obrigatória`,

  list: `Lista`,
  serialNumber: `Número de Série`,
  dataType: `Tipo de Dado`,
  dateCreated: `Data de Criação`,
  dateChange: `Data de Alteração`,
  endDate: `Data de Término`,
  entryDate: `Data de Entrada`,
  entryText: `Descrição do Log`,
  origin: `Origem`,
  type: `Tipo`,
  notifications: `Notificações`,
  profile: `Perfil`,
  selected: `selecionados`,
  tooltipTitle: `Por favor selecione um ou mais items na tabela e depois pressione este botão.`,
  chooseFile: `Escolher Ficheiro`,
  noFile: `Nenhum ficheiro selecionado`,
  file: `Ficheiro`,
  version: `Versão`,
  chargingSessions: `Sessão de Carregamento`,
  createChargingSession: `Criar Sessão de Carregamento`,
  actionToPerfom: `Qual ação de carregamento você deseja realizar:`,
  terminate: `Terminar Sessão`,
  create: `Iniciar Sessão`,
  agents: `Agentes`,
  agent: `Agente`,
  maxPower: `Potência máxima`,
  dataNotFound: `Dados não encontrados`,
  close: `Fechar`,
  nome: `Nome `,
  createButton: `Criar`,
  agentsList: `Lista de Agentes`,
  addAgent: `Adicionar Agente`,
  editAgent: `Editar Agente`,
  newAgent: `Novo Agente`,
  updateFirmware: `Atualizar Firmware`,
  uploadFirmware: `Carregar Firmware`,
  firmware: `Firmware`,
  firmwares: `Firmwares`,
  options: `Options`,
  fileName: `Nome do Ficheiro`,
  execute: `Executar`,
  location: `Localização`,
  addressLine1: `Endereço 1`,
  addressLine2: `Endereço 2`,
  addressLine3: `Endereço 3`,
  addressPostalCode: `Código Postal`,
  groups: `Grupos`,
  userRole: `Função do Utilizador`,
  paymentsManagement: `Gestão de Pagamentos`,
  paymentStatus: `Estado do Pagamento`,
  payments: `Pagamentos`,
  paymentsList: `Lista de Pagamentos`,
  chargementList: 'Lista de carregamentos',
  paymentType: `Tipo de Pagamento`,
  invoices: `Faturas`,
  invoicesList: `Lista de Faturas`,
  invoiceFile: `Ficheiro da Fatura`,
  paymentLogs: `Registo de Pagamentos`,
  paymentLogsList: `Lista de Registo de Pagamentos`,
  networks: `Redes`,
  updateNetwork: `Atualizar Rede`,
  chooseCharger: `Escolha um carregador para receber atualização de rede`,
  manageBillingMethod: `Gerir Método de Pagamento`,
  manageTaxFree: `Gerir Isenção de Imposto`,
  paymentMethods: `Métodos de Pagamento`,
  billingType: `Tipo de cobrança`,
  billing: `Faturação`,
  billingMethod: `Método de Cobrança`,
  minValue: `Valor mínimo `,
  taxFree: `Isenção de Imposto`,
  price: `Preço`,
  details: `Detalhes`,
  publicAddress: `Endereço Público`,
  privateAddress: `Endereço Privado`,
  macAddress: `Endereço MAC`,
  port: `Porta`,
  gateway: `Gateway`,
  subnetMask: `Máscara de Sub-rede`,
  dns: `DNS`,
  wifiSSid: `Wifi SSID`,
  wifiPassword: `Wifi Password`,
  dataNotFound: `Dados não encontrados`,
  deleteProvider: `Tem certeza de que deseja excluir o provedor`,
  deleteCharger: `Tem certeza de que deseja excluir o carregador`,

  tariffs: 'Tarifas',
  tariff: 'Tarifa',
  transactions: 'Transações',
  confirmation: 'Confirmação',
  enable: 'Ativar',
  disable: 'Desativar',
  disableMessage: 'Desativar todos estes carregadores selecionados?',
  enabledMessage: 'Ativar todos estes carregadores selecionados?',
  deleteConfirmMessage: 'Tem certeza de que deseja excluir todos esses carregadores selecionados?',

  deleteSelectedUsers: 'Tem certeza de que deseja excluir todos os utilizadores selecionados?',
  mangePaymentTypeChargers: `Aqui pode gerir o tipo de pagamento para os carregadores selecionados.`,

  // CHARGER STATES
  operationSusscessfuly: `Operação realizada com sucesso`,
  notConnected: `Não Conectado`,
  connected: `Conectado`,
  evCharging: `Veículo a Carregar`,
  evConnected: `Veículo Conectado`,
  evNotConnected: `Carregador disponivel`,
  standby: `Em Espera`,
  freeCharge: `Carreg. Gratis`,
  status: `Estado`,
  userGroups: `Grupos de Utilizadores`,
  currency: 'Moeda',
  private: `Privado?`,
  paymentType: 'Tipo de Pagamento',
  habilitarfaturacao: 'Ativar faturação',
  openFreeCharge: `Ativar carregamento gratuito`,
  remove: 'Remover',
  command: ` Comando`,
  message: `Mensagem`,
  availability: `Availability`,
  confKey: `Chave de configuração`,
  sendCommand: `Enviar comando`,
  deleteCurrentCharger: 'Tem certeza de que deseja excluir este carregador?',
  saveChanges: 'Guardar Alterações',
  serialNumberRequired: 'O número de série é obrigatório',
  chargerRequired: `Um carregador é obrigatório`,
  vehicleRequired: `Um veículo é obrigatório`,
  optionRequired: `Uma opção é obrigatória`,
  deleteCharger: 'Tem certeza de que deseja excluir o carregador',
  chargerGroups: 'Grupo de carregadores',
  chargerGroup: 'Grupos',
  chargerGrop: `Grupos de Carregador`,
  chargerGropuAssociate: `Carregadores Associados a -`,
  fromGroup: `deste grupo?`,
  moeda: `Moeda`,
  providersGroups: `Grupos de Provedores`,
  faturation: `Faturação`,
  minWalletValue: `Valor min. wallet`,
  creditsAmount: 'Quantidade de Créditos',
  addCreditsToUser: 'Adicionar Créditos ao Utilizador',
  removeFromGroup: 'Remover do grupo',
  deleteAllGroupsMessage: 'Tem certeza de que deseja excluir todos os grupos selecionados?',
  deleteProviders: `Tem certeza de que você deseja excluir todos esses provedores?`,
  addToGroup: 'Adicionar ao grupo',
  defineTariffPrice: `Defina o preço para cada tarifa`,
  tariffPrice: `O preço deve ser definido na sua moeda local`,
  chargingUpTo: ` - carregamento até`,
  deleteUser: 'Tem certeza de que deseja excluir o utilizador',
  searchEmailUsername: 'Pesquisar por email ou nome de utilizador',
  usersAssociateTo: `Utilizadores Associados a -`,
  deleteProvider: 'Tem certeza de que deseja excluir o provedor',
  deleteGroup: 'Tem certeza de que deseja excluir o grupo',
  active: `Ativo`,
  inactive: `Inativo`,
  addGroup: 'Adicionar grupo',
  editGroup: 'Editar grupo',
  providerGroups: 'Grupos de Provedores',
  editChargerInformation: 'Editar Informação do Carregador',
  providerGroup: 'Grupo',
  changeProvider: 'Alterar Provedor',
  changeWifiNetwork: 'Alterar Rede Wifi',
  coefficient: 'Coeficiente',

  providerInformation: 'Informação do Provedor',

  userChargeHistory: 'Histórico de Carregamentos',

  addProviderFirst: 'Para adicionar um método de pagamento, primeiro adicione um provedor',

  generatePaymentLogsChart: 'Gerar Gráfico de Pagamentos',

  deleteBrand: 'Tem a certeza de que pretende eliminar a marca ',
  deleteVehicle: 'Tem a certeza de que pretende eliminar o veículo ',
  deleteOutlet: 'Tem a certeza de que pretende eliminar a tomada do veículo ',
  deleteModel: 'Tem certeza de que você deseja excluir o modelo ',

  timeStart: 'Hora de Início',
  timeEnd: 'Hora de Fim',
  totalEnergy: 'Energia Total',
  totalCost: 'Custo Total',

  duration: 'Duração',

  stateDescription: {
    notConnected: 'O carregador está OFFLINE',
    evCharging: 'O veículo está a carregar',
    evConnected: 'O carregador está ONLINE e com um veículo conectado',
    evNotConnected: 'O carregador está ONLINE, sem nenhum veículo conectado',
    standby: 'O carregador foi ligado pela primeira vez e está a aguardar configuração',
    noHeart: 'O carregador está ONLINE, mas está sem TERRA',
  },

  state: 'Estado',
  public1: `Público`,
  private1: `Privado`,

  copyGroup: `Copiar Grupo`,
  groupCopySucessful: `O grupo foi copiado com sucesso`,

  chargements: 'Carregamentos',
  energy: 'Energia',
  yes: 'Sim',
  no: 'Não',
  date: 'Data',
  range: 'Intervalo',
  hourly: 'Por hora',
  daily: 'Diáriamente',
  weekly: 'Semanalmente',
  biweekly: 'Quinzenalmente',
  monthly: 'Mensalmente',
  yearly: 'Anualmente',

  addTax: 'Adicionar Imposto',
  editTax: 'Editar Imposto',
  tax: 'Imposto',
  minWalletValue: 'Valor minimo na carteira',
  openMultiSeccion: 'Ativar sessões múltiplas',
  taxes: 'Impostos',
  taxesList: 'Lista de Impostos',

  deleteItemConfirmation: 'Tem certeza de que deseja excluir o item selecionado?',

  value: 'Valor',
  private: 'Privado?',
  timeAvaileble:
    'O horário de início da disponibilidade do carregador tem se ser menor que o horário do término da disponibilidade do carregador!',

  deleteBrand: 'Tem a certeza de que pretende eliminar a marca ',
  deleteVehicle: 'Tem a certeza de que pretende eliminar o veículo ',
  deleteOutlet: 'Tem a certeza de que pretende eliminar a tomada do veículo ',
  deleteModel: 'Tem certeza de que você deseja excluir o modelo ',

  // ------------------------Required data------------------------

  firstnameRequired: `O primeiro nome é obrigatório`,
  lastnameRequired: `O apelido é obrigatório`,
  passwordConfirmRequired: `Confirmação de senha é obrigatória`,
  passwordMatch: `As senhas não coincidem`,
  minimunLength: `A senha deve ter pelo menos 8 caracteres`,
  emailRequired: `Email é obrigatório`,
  userNameRiquired: `Nome de utilizador é obrigatório`,
  phoneRequired: `Telefone é obrigatório`,
  descriptionRequired: `Descrição é obrigatório`,

  passwordRequired: `Password é obrigatório`,
  nameRequired: `Nome é obrigatório`,
  currencyRequired: `Moeda é obrigatório`,
  powerRequired: `Potência é obrigatoria`,
  deleteTariff: `Tem certeza de que deseja excluir tarifa `,
  taxeRequired: `Imposto é obrigatório`,
  counrtyRequired: `Pais é obrigatório`,
  websiteRequied: `Website é obrigatório`,
  connectorRequired: `O conector é necessário`,
  emailValide: `Email inválido`,
  addressRequired: `Endereco é obrigatorio`,
  postalCodeRequired: `Código postal é obrigatorio`,
  providerRequired: `O provedor é obrigatorio`,
  paymentMethodRequired: `Método de pagamento é obrigatorio`,
  removeLocation: 'Remover localização',
  editLocation: 'Editar localização',
  chargerDetails: 'Detalhes do Carregador',
  rate: 'Tarifa',
  verifyEmail: `Verifique o seu email`,
  verifyEmailTitle: `Verifique o seu email para ativar a sua conta.`,

  noResultsFor: `Não foram encontrados resultados para `,
  checkingKeywords: `. Tente verificar se há erros de digitação ou usar palavras completas.`,
  pleaseEnterKeywords: `Introduza palavras-chave`,

  removeConnectorConfirmation: `Tem certeza que deseja remover este conector?`,

  chargingProfile: `Perfil de Carregamento`,
  chargingProfileRequired: `Perfil de Carregamento é obrigatório`,
  removeProfie: 'Remover Perfil',
  removeProfileConfirm: 'Tem certeza que deseja remover este perfil de carregamento?',
  stackLevelIteger: 'Nível de pilha deve ser um número inteiro',
  stackLevelrequired: 'Nível de pilha é obrigatório',
  chargingProfileKindRequired: 'Tipo de perfil de carregamento é obrigatório',
  chargingRateUnitRequired: 'Unidade de taxa de carregamento é obrigatório',
  durationMustBeIteger: 'Duração deve ser um número inteiro',
  SchedulePeriodrequired: 'Período de programação é obrigatório',
  startPeriodRequired: 'Período de início é obrigatório',
  limitIsRequired: 'Limite é obrigatório',
  addSchedulePeriod: 'Adicionar Período',
  addProfile: 'Adicionar Perfil',

  stackLevel: 'Nível de pilha',
  chargingProfilePurpose: 'Propósito do perfil',
  chargingProfileKind: 'Tipo de perfil',
  recurrenceKind: 'Tipo de recorrencia',
  chargingRateUnit: 'Unidade de taxa de carregamento',
  minChargingRate: 'Taxa minima de carregamento',
  duration: 'Duração',
  startPeriod: 'Período de início',
  limit: 'Limite',
  numberPhases: 'Número de fases',
  schedulePeriod: 'Período de programação',
  validFrom: 'Valido de',
  validTo: 'Valido para',
  startSchedule: 'Inicio de programação',
  viewProviles: 'Ver Perfil',

  chargerGroupRequired: 'Grupo de carregadores é obrigatório',
  company: 'Empresa',
  
  firmwareRequired: `Firmware é obrigatório`,
  retrieveDateRequired: `Data de recuperação é obrigatória`,

  available: {
    from: `Disponível de`,
    until: `Disponível até`,
  },

  deleteChargingProfiles: `Tem certeza que deseja excluir o perfil de carregamento?`,
  deleteChargingProfile: `Eliminar Perfil de Carregamento`,
  start_schedule: 'Horário de Início',

  valid: {
    from: 'Valido de',
    until: 'Valido até',
  },

  states: 'Estados',
  addressLine: 'Endereço',
  acess: 'Acesso',
  glossary: 'Glossário',
  filter: 'Filtro',
  multipleSessions: 'Sessões Múltiplas',
  exportToExcel: 'Exportar para Excel',
  chargingReport: `Relatório de Carregamento`,
  chargeReportsList: `Lista de Relatórios de Carregamento`,
  chargingReports: `Relatórios de Carregamento`,
  user_charger: 'Utilizador / Carregador',
  availabilityWarning:
    'O horário de início da disponibilidade do carregador tem se ser menor que o horário do término da disponibilidade do carregador!',

  associateUser: 'Associar RFID(s) ao Cliente',
  removeRFIDToUser: 'Remover RFID(s) do Cliente',
  removeRFIDConfirm: 'Remover RFID(s) de todos os clientes selecionados?',
  addChargerGroup: 'Adicionar grupo de carregadores',
  editChargerGroup: 'Editar grupo de carregadores',
  rfiList: 'Lista de RFID',

  provisioningDate: 'Data de Aprovisionamento',
  currentPerPhase: `Corrente por fase`,

  pictureUnapproved: `Imagem não aprovada, selecione para aprovar`,

  manufacturer: 'Fabricante',
  firmware_version: 'Versão do Firmware',

  search: {
    email: 'Pesquisar por email',
    username: 'Pesquisar por nome de utilizador',
    emailOrUsername: 'Pesquisar por email ou nome de utilizador',
    button: 'Pesquisar',
  },

  removeRFID: 'Desassociar RFID',
  deleteRFIDMEssage: 'Tem certeza que deseja eliminar o RFID ',
  removeRFIDConfirmation: 'Tem certeza que deseja remover RFID ',
  fromUser: ' do utilizador ',
  disassociate: 'Desassociar',

  imageRequired: 'Imagem é obrigatório',

  information: 'Informação',
  network: 'Rede',

  chargerReport: {
    chargerReport: 'Relatório de Carregamento',
    generate: 'Gerar Relatório de Carregamento',
    reports: 'Relatórios de Carregamento',
    label: 'Utilizador/Carregador',
  },

  date: {
    start: 'Data de Início',
    end: 'Data de Fim',
  },

  commands: {
    start: `Iniciar carregamento`,
    stop: `Terminar carregamento`,
    startDebugMode: `Iniciar modo debug`,
    stopDebugMode: `Terminar modo debug`,
    foreChargeStop: `Forçar término de carregamento`,
  },
};

export default pt;
